import http from '../index'

// 用户相关的 API
export const userApi = {
  // 用户登录
  login(data) {
    return http.post('/api/v3/users/signin', {
      account: data.account,
      password: data.password
    })
  },

  // 获取用户信息
  getUserInfo() {
    return http.get('/user/info')
  },

  // 获取用户信息
  getUsersInfo() {
    return http.get('/api/v3/users/info')
  },

  // 更新用户信息
  updateUserInfo(data) {
    return http.put('/user/info', data)
  },

  // 修改密码
  changePassword(data) {
    return http.post('/user/change-password', data)
  },

  // 上传头像
  uploadAvatar(file, onProgress) {
    return http.upload('/user/avatar', file, onProgress)
  },

  // 发送验证码
  sendVerificationCode(data) {
    return http.post('/api/v3/users/vcode-send', {
      account: data.account,
      template: data.template
    })
  },

  // 检测邮箱是否已注册
  checkEmailValid(data) {
    return http.post('/api/v3/users/email-valid', {
      email: data.email
    })
  },

  // 检测手机号是否已注册
  checkPhoneValid(data) {
    return http.post('/api/v3/users/phone-valid', {
      countryCode: data.countryCode,
      phone: data.phone
    })
  },

  // 重置密码
  resetPassword(data) {
    return http.post('/api/v3/users/resetpwd', {
      account: data.account,
      password: data.password,
      vcode: data.vcode
    })
  },

  // 注册
  register(data) {
    return http.post('/api/v3/users/email-signup', {
      email: data.email,
      password: data.password,
      vcode: data.vcode
    })
  },

  // 更新驾驶速度
  updateVehicleSpeedLevel(data) {
    return http.put('/api/v3/users', data)
  },

  // 获取国家代码列表
  getCountryCodes() {
    return http.get('/api/v3/countrycodes')
  },

  // 切换身份
  switchIdentity(data) {
    return http.post('/api/v3/users/switch-identity', data)
  },

  // 获取组织成员信息分页
  getOrgMembers(data) {
    return http.get('/api/v3/organizations', data)
  },

  // 获取组织分享二维码
  getGroupQrCode() {
    return http.post('/api/v3/organizations/qrcode')
  },

  // 创建组织
  createOrg(data) {
    return http.post('/api/v3/organizations', data)
  },

  // 更新组织
  updateOrg(data) {
    return http.put('/api/v3/organizations', data)
  },

  // 移除组织成员
  removeOrgMember(data) {
    return http.delete(`/api/v3/organizations/members/${data}`)
  },

  // 退出组织
  leaveOrg() {
    return http.post('/api/v3/organizations/leave')
  },
}

export default userApi 